import React, { useState, useEffect } from "react";
import "./PaymentSuccess.scss";
import graphqlRequest from "../../../requestMethod";
import { useSearchParams, useNavigate } from "react-router-dom";
import logo from "../../../asset/navbar/logo.svg";

const PaymentSuccess = () => {
  const [countdown, setCountdown] = useState(10);
  // console.log("data in payment success:", data);
  // const status = data?.status;
  // const refId = data?.cf_order_id;
  // const amount = data?.amount;
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);

  // console.log("paymentData in payment success:", paymentData);
  const status = paymentData?.status;
  const refId = paymentData?.cf_order_id;
  const amount = paymentData?.amount;

  const data = localStorage.getItem("auth");
  const token = JSON.parse(data)?.accessToken;

  const fetchCreateOrder = async (createdOrderId) => {
    try {
      setLoading(true);
      const query = `
           query{
      withAuth(token: "${token}"){
        fetchCashfreeOrder(orderId: "${createdOrderId}") {
          currency
          cf_order_id
          order_id
          payment_session_id
          amount
          status
          paymentMode
          paymentCreatedAt
        }
      }
    }
          `;

      const response = await graphqlRequest(query);
      console.log("Cashfree createOrder response:", response);
      const data = response?.data?.withAuth?.fetchCashfreeOrder;
      // console.log("dataForSuccess", data);
      setPaymentData(data);
      
    } catch (err) {
      console.error("Error creating order:", err);
    }finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    // console.log("urlParams:", urlParams);
    const orderIdFromUrl = urlParams.get("order_id");
    // console.log("orderId from url:", orderIdFromUrl);
    const txStatus = urlParams.get("txStatus");
    // console.log("txStatus from url:", txStatus);

    if (orderIdFromUrl) {
      fetchCreateOrder(orderIdFromUrl);
    }
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    } else {
      window.location.href = "/billing";
    }
  }, [countdown]);

  const handleRedirect = () => {
    window.location.href = "/billing";
  };

    if (loading) {
      return (
        <div className="modal-overlay">
          <div className="success-card loader-card">
            {/* <h2 className="brand-name">Jobizo</h2> */}
            <img className="logo-img" src={logo} alt="jobizo-logo" />
            <div className="spinner"></div>
            <p className="loading-text">Checking your payment status...</p>
          </div>
        </div>
      );
    }


 return (
   <div className="modal-overlay">
     <div className="success-card" onClick={(e) => e.stopPropagation()}>
       {/* <h2 className="brand-name">Jobizo</h2> */}
       <img className="logo-img" src={logo} alt="jobizo-logo" />
       <div className={`check-circle ${status !== "PAID" ? "failed" : ""}`}>
         {status === "PAID" ? (
           <svg className="check-icon" fill="currentColor" viewBox="0 0 20 20">
             <path
               fillRule="evenodd"
               d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
               clipRule="evenodd"
             />
           </svg>
         ) : (
           <svg className="cross-icon" fill="currentColor" viewBox="0 0 20 20">
             <path
               fillRule="evenodd"
               d="M10 18a8 8 0 100-16 8 8 0 000 16zM6.707 6.293a1 1 0 00-1.414 1.414L8.586 10l-3.293 3.293a1 1 0 101.414 1.414L10 11.414l3.293 3.293a1 1 0 001.414-1.414L11.414 10l3.293-3.293a1 1 0 00-1.414-1.414L10 8.586 6.707 6.293z"
               clipRule="evenodd"
             />
           </svg>
         )}
       </div>
       <h1 className="success-title">
         {status === "PAID" ? "SUCCESS" : "FAILED"}
       </h1>
       <p className="payment-info">Paid INR {amount}</p>
       <p className="ref-info">Ref Id: {refId || "N/A"}</p>
       <p className="countdown">Redirecting in {countdown} seconds...</p>
       <button className="close-btn" onClick={handleRedirect}>
         Go to Billing
       </button>
     </div>
   </div>
 );
};

export default PaymentSuccess;
